import { t } from "@/i18n-js/instance";
import type { Event } from "@circle-react/types";
import { Tabs } from "@circle-react-uikit/Tabs";
import { Typography } from "@circle-react-uikit/Typography";
import { PEOPLE_TABS, isLiveRoom } from "../../utils";
import { DownloadCSVButton } from "./DownloadCSVButton";
import { PeopleBody } from "./PeopleBody";
import { useCanDownloadAttendeeList } from "./hooks/useCanDownloadAttendeeList";
import { useFormSections } from "./hooks/useFormSections";

interface PeopleProps {
  event: Event;
}

export const People = ({ event }: PeopleProps) => {
  const isRoom = isLiveRoom(event);
  const { onTabClick, currentTab, tabs } = useFormSections(isRoom);
  const canDownloadAttendeeList = useCanDownloadAttendeeList();
  const shouldDisplayDownloadCSVButton =
    canDownloadAttendeeList && currentTab?.key === PEOPLE_TABS.ATTENDEES;

  return (
    <>
      <Typography.TitleXl>{t("events.create.form.people")}</Typography.TitleXl>
      {currentTab?.label && (
        <div className="relative">
          <Tabs
            variant="underline"
            className="sticky"
            wrapperClassName="overflow-x-auto overflow-y-hidden"
            controlled
            activeTab={currentTab.label}
            onClick={onTabClick}
            options={tabs}
          />
          {shouldDisplayDownloadCSVButton && (
            <div className="absolute bottom-2 right-0">
              <DownloadCSVButton event={event} />
            </div>
          )}
        </div>
      )}
      <PeopleBody event={event} currentTab={currentTab} />
    </>
  );
};
